// src/components/AdminRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const AdminRoute = () => {
  const { user } = useUser();

  // O componente ProtectedRoute já garante que 'user' existe,
  // mas uma verificação dupla não faz mal.
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Verifica se o usuário tem a permissão necessária
  const isAdmin = user.role === 'admin-dev' || user.role === 'admin-op';
  if (!isAdmin) {
    // Se não for admin, redireciona para a home com uma mensagem (opcional)
    return <Navigate to="/home" replace />;
  }

  // Se for admin, renderiza o componente da rota (UserManagementScreen)
  return <Outlet />;
};

export default AdminRoute;